
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcPoiCard as ObcPoiCardElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-card/poi-card.js';
 import {PoiCardClickDetail} from '@oicl/openbridge-webcomponents/dist/ar/poi-card/poi-card.js';
 export type {PoiCardClickDetail} from '@oicl/openbridge-webcomponents/dist/ar/poi-card/poi-card.js';
 

 
 export const ObcPoiCard = createComponent({
   react: React,
   tagName: 'obc-poi-card',
   elementClass: ObcPoiCardElement,
   events: {
     
     onCardClick: 'card-click' as EventName<CustomEvent<PoiCardClickDetail>>,
   }
  });
 
 